import i18next from "i18next"
import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import styles from "./index.module.css"

export const Hero: React.FC = () => {
  const { t } = useTranslation()
  const currentLang = i18next.language
  const getDividendUrl: () => string = () => {
    return currentLang === "ru"
      ? "/upload/iblock/03d/l0mpkoyqrkrecdx2gkkdjfmztw5owtba/Dividendnaya-politika-AFK-Sistema_2024.pdf"
      : "/upload/iblock/697/pyeuvsa0wvc4zpxq8g08krhui3yn0pe6/Dividend-Policy_Sistema_2024.pdf"
  }

  return (
    <Wrapper className={styles.Wrapper}>
      <div className="container">
        <Heading as="div" className={styles.Title} like="h1">
          <Raw html={t("stock.Dividends.Hero.Title")} />
        </Heading>

        <Link className={styles.Link} href={getDividendUrl()} view="arrow">
          <Raw html={t("stock.Dividends.Hero.Link")} />
        </Link>

        <div className={styles.Facts}>
          <div className={styles.Fact}>
            <Heading className={styles.FactName} like="h2">
              <Raw html={t("stock.Dividends.Hero.Fact_01.Title")} />
            </Heading>

            <div>
              <Raw html={t("stock.Dividends.Hero.Fact_01.Text")} />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}
